module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/sidebar-shield-active.c2b48cd4.svg";